export default __webpack_public_path__ + "static/media/collaborative.b12bea2a.webp";